import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { ClientService } from '@dss-libs/shared/data-access/clients';
import { ITokenModel, LocalstorageConstants } from '@dss-libs/shared/type/common-types';
import { KeycloakAuthService } from '@dss-libs/shared/data-access/auth';
import { parseJwtClaims } from '@dss-libs/shared/utility/common-utilities';
export const ClientGuard: CanActivateFn = () => {
  const clientService = inject(ClientService);
  const router = inject(Router);

  const jwtToken = inject(KeycloakAuthService).getToken();
  if (jwtToken) {
    const parsedPayload: ITokenModel = parseJwtClaims(jwtToken);
    clientService.updateResolvedToken(parsedPayload);
  }

  const userClientsResource = clientService.userClientsResource();
  return toObservable(userClientsResource.status).pipe(
    filter((status) => status === 'resolved' || status === 'error'),
    map(() => {
      if (!userClientsResource.hasValue()) return false;
      const clients = userClientsResource.value();
      if (clients.length === 0) {
        window.localStorage.removeItem(LocalstorageConstants.CLIENT_ID);
        return router.createUrlTree(['/createClient']);
      }
      const currentClientId = window.localStorage.getItem(LocalstorageConstants.CLIENT_ID);
      if (!currentClientId || !clients.find((client) => client.id === currentClientId)) {
        window.localStorage.setItem(LocalstorageConstants.CLIENT_ID, clients[0].id);
        window.location.reload();
      }
      return true;
    }),
    take(1)
  );
};
